export default __webpack_public_path__ + "static/media/pin01@2x.5ad363be.png";